import { notifications } from "@mantine/notifications"
import { useMutation, UseMutationOptions } from "@tanstack/react-query"
import { AxiosError } from "axios"

import { httpClient } from "~/backend/axios"

type ToggleUserStatusMutationType = {
  id: string
  active: boolean
  email: string
  name: string
  organizationId: string
}

const NOTIFICATIONS = {
  SUCCESS: {
    autoClose: 10000,
    styles: {
      description: {
        maxHeight: "unset",
        height: "min-content",
        textOverflow: "unset",
      },
    },
    message: `User status updated`,
    color: "green",
  },
  ERROR: {
    title: "Error",
    message: "An error occurred while toggling the user status",
    color: "red",
  },
}

export const useToggleUserActiveStatusMutation = (
  options?: UseMutationOptions<
    ToggleUserStatusMutationType,
    AxiosError,
    ToggleUserStatusMutationType
  >
) => {
  return useMutation<
    ToggleUserStatusMutationType,
    AxiosError,
    ToggleUserStatusMutationType
  >({
    ...options,
    mutationFn: async (user: ToggleUserStatusMutationType) => {
      const res = await httpClient.put(`/v1/user/${user.id}`, user)
      return res.data
    },
    onSuccess: async (data, variables, onMutateResult, context) => {
      options?.onSuccess?.(data, variables, onMutateResult, context)
      notifications.show(NOTIFICATIONS.SUCCESS)
      return true
    },
    onError: (error, variables, onMutateResult, context) => {
      options?.onError?.(error, variables, onMutateResult, context)
      notifications.show(NOTIFICATIONS.ERROR)
    },
  })
}
